<template>
    <section class="py-16">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-10 col-start-2">
                    <div class="px-12 py-16 bg-dim_gold_2 relative">

                        <div class="h-[220px] w-[220px] border-b-4 border-s-4 border-solid border-gray-400 absolute -left-4 -bottom-4"></div>
                        <div class="h-[220px] w-[220px] border-t-4 border-e-4 border-solid border-gray-400 absolute -right-4 -top-4"></div>

                        <div class="grid grid-cols-2 gap-6 items-center">
                            <div class="col-span-1">
                                <h2 class="text-5xl leading-tight text-dim_dark mb-8">
                                    Оставьте заявку
                                </h2>
                                <p class="text-lg  text-dim_dark">
                                    В течение 5 минут вы получите <br> объективное заключение и <br> примерную стоимость услуг
                                </p>
                            </div>
                            <div class="col-span-1">
                                <form class="grid grid-cols-2 gap-6 items-center">
                                    <div class="col-span-1">
                                        <label class="text-lg">Имя</label>
                                        <input type="text" placeholder="Введите имя" class="w-full mt-2 py-2 border-b bg-transparent  border-dim_dark outline-none">
                                    </div>
                                    <div class="col-span-1">
                                        <label class="text-lg">Телефон</label>
                                        <input type="text" placeholder="+ 7(" class="w-full mt-2 py-2 border-b bg-transparent  border-dim_dark outline-none">
                                    </div>
                                    <div class="col-span-2">
                                        <label class="text-lg">Сообщение</label>
                                        <input type="text" placeholder="Опишите ваш проект" class="w-full mt-2 py-2 border-b bg-transparent  border-dim_dark outline-none">
                                    </div>
                                    <div class="col-span-1">
                                        <button class="rounded w-full py-4 text-xl text-black bg-white border border-solid border-white hover:border-black hover:bg-dim_dark hover:text-white">
                                            Оставить заявку
                                        </button>
                                    </div>
                                    <div class="col-span-1">
                                        <div class="relative flex items-center">
                                            <div class="flex h-5 items-center">
                                            <input id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" >
                                            </div>
                                            <div class="ml-3 text-sm">
                                            <label for="comments" class="text-gray-700 text-md">Согласен с политикой конфиденциальности</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>